import AppointmentListPage from "./pages/AppointmentListPage";
import AppointmentDetailPage from "./pages/AppointmentDetailPage";
import AppointmentDashboardPage from "./pages/AppointmentDashboardPage";
import AppointmentCreatePage from "./pages/AppointmentCreatePage";
import AppointmentProductDashboardPage from "./pages/AppointmentProductDashboardPage";

export const appointmentRoutes = (prefix = "appointments") => [
  {
    name: "AppointmentListPage",
    path: `${prefix}/search`,
    component: AppointmentListPage
  },
  {
    name: "AppointmentCreatePage",
    path: `${prefix}/create`,
    component: AppointmentCreatePage
  },
  {
    name: "AppointmentProductDashboardPage",
    path: `${prefix}/product`,
    component: AppointmentProductDashboardPage
  },
  {
    name: "AppointmentDashboardPage",
    path: `${prefix}/list`,
    component: AppointmentDashboardPage
  },
  {
    name: "AppointmentDetailPage",
    path: `${prefix}/:id`,
    component: AppointmentDetailPage
  }
];
